import { render, staticRenderFns } from "./fullAttachmentShow.vue?vue&type=template&id=581c5b24&scoped=true"
import script from "./fullAttachmentShow.vue?vue&type=script&lang=js"
export * from "./fullAttachmentShow.vue?vue&type=script&lang=js"
import style0 from "./fullAttachmentShow.vue?vue&type=style&index=0&id=581c5b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c5b24",
  null
  
)

export default component.exports